import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { GovernmentAccountTab } from './tabs/GovernmentAccountTab';
import { PassportSeamanBookTab } from './tabs/PassportSeamanBookTab';
import { LicenseInformationTab } from './tabs/LicenseInformationTab';
import { EmployeeAccountBankTab } from './tabs/EmployeeBankTab';
import { FEATURES } from '../../../../../config/features';


export function AccountsTab({
  // Government
  sss,
  tin,
  philhealth,
  pagibig,
  setsss,
  setTin,
  setPhilhealth,
  setPagibig,
  // Passport & Seaman
  passport,
  setPassport,
  passportIssueDate,
  setPassportIssueDate,
  passportExpiryDate,
  setPassportExpiryDate,
  seamansBookNumber,
  setSeamansBookNumber,
  seamansBookIssueDate,
  setSeamansBookIssueDate,
  seamansBookExpiryDate,
  setSeamansBookExpiryDate,

  // License Information
  licenseCode,
  setLicenseCode,
  licenseDescription,
  setLicenseDescription,
  licenseNumber,
  setLicenseNumber,
  licenseQualified,
  setLicenseQualified,
  licenseExpirationDate,
  setLicenseExpirationDate,

  // Bank Info
  employeeBankAccounts,
  setEmployeeBankAccounts,

  // Common
  isEditMode
}) {

  // Determine tab labels based on features
  const getPassportTabLabel = () => {
    if (FEATURES.EMPLOYEE_ACCOUNT_SEAMAN_BOOK) {
      return "Passport and Seaman’s Book";
    }
    return "Passport";
  };

  return (
    <div style={{ width: "100%" }}>
      <Tabs forceRenderTabPanel={true}>
        <TabList>
          <Tab>Government Accounts</Tab>
          <Tab>{getPassportTabLabel()}</Tab>
          {FEATURES.EMPLOYEE_ACCOUNT_LICENSE_INFORMATION &&
            <Tab>License Information</Tab>
          }
          <Tab>Employee Account Bank</Tab>
        </TabList>

        {/* 1. Government Accounts */}
        <TabPanel>
          <GovernmentAccountTab
            sss={sss}
            tin={tin}
            philhealth={philhealth}
            pagibig={pagibig}
            setsss={setsss}
            setTin={setTin}
            setPhilhealth={setPhilhealth}
            setPagibig={setPagibig}

            isEditMode={isEditMode}
          />
        </TabPanel>

        {/* 2. Passport and Seaman’s Book */}
        <TabPanel>
          <PassportSeamanBookTab
            passport={passport}
            setPassport={setPassport}
            passportIssueDate={passportIssueDate}
            setPassportIssueDate={setPassportIssueDate}
            passportExpiryDate={passportExpiryDate}
            setPassportExpiryDate={setPassportExpiryDate}
            seamansBookNumber={seamansBookNumber}
            setSeamansBookNumber={setSeamansBookNumber}
            seamansBookIssueDate={seamansBookIssueDate}
            setSeamansBookIssueDate={setSeamansBookIssueDate}
            seamansBookExpiryDate={seamansBookExpiryDate}
            setSeamansBookExpiryDate={setSeamansBookExpiryDate}

            isEditMode={isEditMode}
          />
        </TabPanel>

        {/* 3. License Information - Only show if feature is enabled */}
        {FEATURES.EMPLOYEE_ACCOUNT_LICENSE_INFORMATION && (
          <TabPanel>
            <LicenseInformationTab
              licenseCode={licenseCode}
              setLicenseCode={setLicenseCode}
              licenseDescription={licenseDescription}
              setLicenseDescription={setLicenseDescription}
              licenseNumber={licenseNumber}
              setLicenseNumber={setLicenseNumber}
              licenseQualified={licenseQualified}
              setLicenseQualified={setLicenseQualified}
              licenseExpirationDate={licenseExpirationDate}
              setLicenseExpirationDate={setLicenseExpirationDate}

              isEditMode={isEditMode}
            />
          </TabPanel>
        )}

        {/* 4. Employee Account Bank */}
        <TabPanel>
          {/* We only pass the Values and Setters now */}
          <EmployeeAccountBankTab
            employeeBankAccounts={employeeBankAccounts}
            setEmployeeBankAccounts={setEmployeeBankAccounts}

            isEditMode={isEditMode}
          />
        </TabPanel>

      </Tabs>
    </div>
  )
}